import React, { useState, useEffect } from 'react';
import axios from 'axios';
import * as XLSX from 'xlsx';
import Swal from 'sweetalert2'; // Pastikan sudah install: npm install sweetalert2

const RekapPage = ({ token }) => {
  const [kelasList, setKelasList] = useState([]);
  const [selectedKelas, setSelectedKelas] = useState('');
  const [tanggal, setTanggal] = useState(new Date().toISOString().split('T')[0]);
  
  // Data Mentah & Grouping
  const [rawData, setRawData] = useState([]);
  const [groupedData, setGroupedData] = useState([]);
  
  // Statistik: (h, s, i, a, d, t)
  const [stats, setStats] = useState({ h: 0, s: 0, i: 0, a: 0, d: 0, t: 0 });

  useEffect(() => {
    axios.get('https://sijapan.sman10fajarharapan.sch.id/api/kelas', { headers: { Authorization: `Bearer ${token}` } })
      .then(res => setKelasList(res.data));
  }, [token]);

  const handleCari = async () => {
    if (!selectedKelas) return alert("Pilih kelas dulu!");
    try {
      const res = await axios.get(`https://sijapan.sman10fajarharapan.sch.id/api/absensi`, {
        params: { tanggal, kelas: selectedKelas },
        headers: { Authorization: `Bearer ${token}` }
      });
      
      const data = res.data;
      setRawData(data);

      // 1. HITUNG STATISTIK
      let h=0, s=0, i=0, a=0, d=0, t=0;
      data.forEach(item => {
          if(item.status === 'hadir') h++;
          else if(item.status === 'sakit') s++;
          else if(item.status === 'izin') i++;
          else if(item.status === 'alfa') a++;
          else if(item.status === 'dispen') d++;
          else if(item.status === 'terlambat') t++;
      });
      setStats({ h, s, i, a, d, t });

      // 2. GROUPING DATA BY SISWA
      const groups = {};
      data.forEach(item => {
        const key = item.siswa_id; 
        if (!groups[key]) {
            groups[key] = {
                id: item.siswa_id,
                nama: item.nama_siswa,
                absenList: []
            };
        }
        groups[key].absenList.push(item);
      });

      // Urutkan Array
      const sortedGroups = Object.values(groups).sort((a, b) => a.nama.localeCompare(b.nama));
      setGroupedData(sortedGroups);

    } catch (err) { alert('Gagal memuat data'); }
  };

  const handlePrint = () => {
    window.print();
  };

  // FUNGSI BARU: LIHAT BUKTI FOTO
  const handleLihatBukti = (url) => {
    Swal.fire({
      imageUrl: url,
      imageAlt: 'Bukti Absen',
      imageHeight: 400, 
      showCloseButton: true,
      showConfirmButton: false,
      background: '#fff',
      backdrop: `rgba(0,0,0,0.8)`
    });
  };
  
  const handleExportExcel = () => {
    if (rawData.length === 0) return alert('Tidak ada data!');
    
    const excelData = rawData.map((item, idx) => ({
      "No": idx + 1,
      "Nama Siswa": item.nama_siswa,
      "Jam": item.jam_mulai ? item.jam_mulai.slice(0,5) : '-',
      "Mata Pelajaran": item.mapel || '-',
      "Status": item.status ? item.status.toUpperCase() : 'BELUM ABSEN',
      "Bukti": item.bukti_foto ? "Ada Foto" : "-" // Info tambahan
    }));

    const ws = XLSX.utils.json_to_sheet(excelData);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Detail Harian");
    XLSX.writeFile(wb, `Laporan_Detail_${selectedKelas}_${tanggal}.xlsx`);
  };

  // Helper Warna Status
  const getStatusStyle = (status) => {
    switch(status) {
        case 'hadir': return { bg: '#dcfce7', color: '#166534', label: 'HADIR' };
        case 'terlambat': return { bg: '#ffedd5', color: '#ea580c', label: 'TERLAMBAT' };
        case 'sakit': return { bg: '#fef9c3', color: '#854d0e', label: 'SAKIT' };
        case 'izin': return { bg: '#dbeafe', color: '#1e40af', label: 'IZIN' };
        case 'alfa': return { bg: '#fee2e2', color: '#991b1b', label: 'ALFA' };
        case 'dispen': return { bg: '#f3e8ff', color: '#6b21a8', label: 'DISPEN' };
        default: return { bg: '#f1f5f9', color: '#64748b', label: '-' };
    }
  };

  return (
    <div style={{ paddingBottom: '50px' }}>
      
      {/* FILTER BAR */}
      <div className="no-print" style={{ marginBottom: '20px' }}>
        <h2 style={{ color: '#1e293b' }}>📊 Laporan Harian Detail</h2>
        <div style={{ display: 'flex', gap: '10px', background: 'white', padding: '15px', borderRadius: '10px', boxShadow: '0 2px 5px rgba(0,0,0,0.05)', flexWrap:'wrap' }}>
            <input type="date" value={tanggal} onChange={e => setTanggal(e.target.value)} style={{ padding: '8px', borderRadius: '6px', border: '1px solid #cbd5e1' }} />
            <select value={selectedKelas} onChange={e => setSelectedKelas(e.target.value)} style={{ padding: '8px', borderRadius: '6px', border: '1px solid #cbd5e1' }}>
                <option value="">-- Pilih Kelas --</option>
                {kelasList.map(k => <option key={k.id} value={k.nama_kelas}>{k.nama_kelas}</option>)}
            </select>
            <button onClick={handleCari} style={{ background: '#4361ee', color: 'white', padding: '8px 20px', borderRadius: '6px', border: 'none', cursor: 'pointer', fontWeight: 'bold' }}>Tampilkan</button>
            <button onClick={handleExportExcel} style={{ background: '#10b981', color: 'white', padding: '8px 20px', borderRadius: '6px', border: 'none', cursor: 'pointer', fontWeight: 'bold' }}>📥 Excel</button>
            <button onClick={handlePrint} style={{ background: '#334155', color: 'white', padding: '8px 20px', borderRadius: '6px', border: 'none', cursor: 'pointer', fontWeight: 'bold' }}>🖨️ Cetak</button>
        </div>
      </div>

      {/* AREA CETAK */}
      <div className="print-area" style={{ background: 'white', padding: '30px', borderRadius: '10px' }}>
          <div style={{ textAlign: 'center', marginBottom: '20px', borderBottom: '2px solid #000', paddingBottom: '10px' }}>
              <h3 style={{ margin: 0 }}>LAPORAN KEHADIRAN HARIAN TERPERINCI</h3>
              <p style={{ margin: '5px 0' }}>Kelas: <b>{selectedKelas || '-'}</b> | Tanggal: <b>{tanggal}</b></p>
          </div>

          {/* Statistik Ringkas */}
          <div style={{ display: 'flex', justifyContent: 'center', gap: '15px', marginBottom: '20px', fontSize: '12px', fontWeight: 'bold', background: '#f8fafc', padding: '10px', borderRadius: '8px', flexWrap:'wrap' }}>
              <span style={{color:'#166534'}}>Hadir: {stats.h}</span> | 
              <span style={{color:'#ea580c'}}>Terlambat: {stats.t}</span> | 
              <span style={{color:'#854d0e'}}>Sakit: {stats.s}</span> | 
              <span style={{color:'#1e40af'}}>Izin: {stats.i}</span> | 
              <span style={{color:'#6b21a8'}}>Dispen: {stats.d}</span> | 
              <span style={{color:'#991b1b'}}>Alfa: {stats.a}</span>
          </div>

          <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: '13px' }} border="1">
              <thead>
                  <tr style={{ background: '#f1f5f9' }}>
                      <th style={{ padding: '8px', width: '40px' }}>No</th>
                      <th style={{ padding: '8px', width: '25%' }}>Nama Siswa</th>
                      <th style={{ padding: '8px', width: '35%' }}>Mata Pelajaran / Jam</th>
                      <th style={{ padding: '8px', width: '20%' }}>Status Kehadiran</th>
                  </tr>
              </thead>
              <tbody>
                  {groupedData.length === 0 ? (
                      <tr><td colSpan="4" style={{ textAlign: 'center', padding: '15px' }}>Tidak ada data absensi.</td></tr>
                  ) : (
                      groupedData.map((siswa, idx) => {
                          const rowCount = siswa.absenList.length;
                          return siswa.absenList.map((absen, subIdx) => {
                              const style = getStatusStyle(absen.status);
                              // URL Foto Bukti
                              const fotoUrl = absen.bukti_foto ? `https://sijapan.sman10fajarharapan.sch.id/uploads/${absen.bukti_foto}` : null;

                              return (
                                <tr key={`${siswa.id}-${subIdx}`}>
                                    {/* Kolom No & Nama (RowSpan) */}
                                    {subIdx === 0 && (
                                        <>
                                            <td rowSpan={rowCount} style={{ textAlign: 'center', padding: '5px', background: '#fff' }}>{idx + 1}</td>
                                            <td rowSpan={rowCount} style={{ padding: '10px', fontWeight: 'bold', background: '#fff', verticalAlign: 'top' }}>
                                                {siswa.nama}
                                            </td>
                                        </>
                                    )}

                                    {/* Kolom Mapel */}
                                    <td style={{ padding: '8px' }}>
                                        <div style={{ fontWeight: 'bold', color: '#334155' }}>{absen.mapel || 'Mapel Umum'}</div>
                                        <div style={{ fontSize: '11px', color: '#64748b' }}>⏰ {absen.jam_mulai ? absen.jam_mulai.slice(0,5) : '-'} WIB</div>
                                    </td>

                                    {/* Kolom Status & Tombol Foto */}
                                    <td style={{ textAlign: 'center', padding: '8px' }}>
                                        <div style={{ display:'flex', alignItems:'center', justifyContent:'center', gap:'8px' }}>
                                            <span style={{ 
                                                background: style.bg, 
                                                color: style.color, 
                                                padding: '5px 12px', 
                                                borderRadius: '20px', 
                                                fontSize: '11px', 
                                                fontWeight: 'bold', 
                                                display: 'inline-block', 
                                                minWidth: '80px' 
                                            }}>
                                                {style.label}
                                            </span>

                                            {/* TOMBOL LIHAT BUKTI (Hanya jika ada foto) */}
                                            {fotoUrl && (
                                                <button 
                                                    onClick={() => handleLihatBukti(fotoUrl)}
                                                    title="Lihat Bukti Foto"
                                                    style={{ 
                                                        background: 'none', border: '1px solid #ccc', borderRadius:'50%', 
                                                        width:'28px', height:'28px', cursor:'pointer', display:'flex', alignItems:'center', justifyContent:'center', fontSize:'14px' 
                                                    }}
                                                >
                                                    📷
                                                </button>
                                            )}
                                        </div>
                                    </td>
                                </tr>
                              );
                          });
                      })
                  )}
              </tbody>
          </table>
          <div style={{ marginTop: '30px', display: 'flex', justifyContent: 'flex-end' }}>
              <div style={{ textAlign: 'center', width: '200px' }}>
                  <p>Mengetahui,<br/>Guru Piket / Wali Kelas</p>
                  <br/><br/><br/>
                  <p>( __________________ )</p>
              </div>
          </div>
      </div>
    </div>
  );
};

export default RekapPage;